<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="icon-cal" viewBox="0 0 512 512">
        <path d="m374 512l-268 0c-90 0-106-32-106-106l0-300c0-80 26-106 106-106l268 0c84 0 106 22 106 106l0 300c0 84-22 106-106 106z m-345-352l0 250c0 64 6 73 73 73l269 0c64 0 74-6 74-73l0-250z m0-32l419 0 0-22c0-68-6-74-74-74l-268 0c-64 0-74 13-74 74l0 22z m227 128l64 0 0-64-64 0z m96-64l0 64 64 0 0-64z m0 160l64 0 0-64-64 0z m-96 0l64 0 0-64-64 0z m-96 0l64 0 0-64-64 0z m-96 0l64 0 0-64-64 0z m0 96l64 0 0-64-64 0z m96 0l64 0 0-64-64 0z m96 0l64 0 0-64-64 0z"/>
      </symbol>
      <symbol id="icon-bed" viewBox="0 0 512 512">
        <path d="m474 241c-14 0-24 6-24 15l0 28c-13-25-32-43-57-43l-226 0c-5 0-8 3-8 8l0 48c0-13-6-26-16-36-20-18-50-16-69 3-17 19-17 47 0 66-4 0-9 2-12 5l0-204c0-11-11-20-25-20-13 0-24 9-24 20l0 349c0 11 11 20 24 20 14 0 25-9 25-20l0-53 388 0 0 57c0 9 10 16 24 16 15 0 25-7 25-16l0-228c0-9-10-15-25-15z m-429 239c0 1-2 4-8 4-5 0-8-3-8-4l0-349c0-1 3-4 8-4 6 0 8 3 8 4z m130-223l218 0c31 0 54 45 57 89l-275 0z m-16 40l0 39c-4-3-8-5-13-6 8-9 13-20 13-33z m-49-32c18 0 33 15 33 32 0 18-15 33-33 33-18 0-32-15-32-33 0-17 14-32 32-32z m340 146l-388 0 0-49c4 0 7-4 7-8 0-4 4-8 8-8l65 0c5 0 8 4 8 8 0 5 4 8 8 8l292 0z m33 71c-6 2-11 2-17 0l0-224c6-2 11-2 17 0z m-331-290l29-35c2-3 3-6 1-9-1-3-4-4-7-4l-49 0 0 16 32 0-30 35c-2 3-2 6-1 9 2 3 4 4 8 4l48 0 0-16z m88-40l47-60c1-3 2-6 0-9-1-2-4-4-7-4l-65 0 0 16 49 0-47 60c-2 2-2 6-1 8 2 3 4 5 8 5l64 0 0-16-48 0z m105-41l63-84c2-2 2-6 1-8-2-3-4-5-7-5l-73 0 0 16 56 0-63 84c-2 3-2 6-1 9 2 3 5 4 8 4l81 0 0-16z"/>
      </symbol>
      <symbol id="icon-cottage" viewBox="0 0 512 512">
        <path d="m505 434l-22 0 0-305 8 0c4 0 8-4 8-8l0-30c0-4-4-7-8-7l-311 0 0-43c0-4-4-7-8-7l-80 0c-4 0-7 3-7 7l0 43-21 0c-4 0-7 3-7 7 0 4 3 8 7 8l420 0 0 15-455 0 0-15 3 0c4 0 8-4 8-8 0-4-4-7-8-7l-11 0c-4 0-7 3-7 7l0 30c0 4 3 8 7 8l8 0 0 305-21 0c-5 0-8 3-8 7l0 30c0 4 3 8 8 8l437 0c4 0 8-4 8-8 0-4-4-7-8-7l-430 0 0-15 482 0 0 15-22 0c-4 0-7 3-7 7 0 4 3 8 7 8l30 0c4 0 7-4 7-8l0-30c0-4-3-7-7-7z m-340-350l-65 0 0-35 65 0z m-121 125l15 0 0 25-15 0z m0 40l15 0 0 25-15 0z m0 40l15 0 0 25-15 0z m0 40l15 0 0 25-15 0z m254 105l-254 0 0-25 254 0z m0-40l-254 0 0-25 254 0z m-224-40l0-145 175 0 0 145z m224-120l-34 0 0-25 34 0z m0 95l0 25-34 0 0-25z m0-80l0 25-34 0 0-25z m0 40l0 25-34 0 0-25z m110 145l-65 0 0-195 65 0z m30-193c0 0 0 0 0 0 0 0 0 0 0 0l0 40c0 0 0 0 0 0 0 0 0 0 0 0l0 40c0 0 0 0 0 0 0 0 0 0 0 0l0 40c0 0 0 0 0 0 0 0 0 0 0 0l0 40c0 0 0 0 0 0 0 0 0 0 0 0l0 33-15 0 0-203c0-4-4-7-8-7l-80 0c-4 0-7 3-7 7l0 203-15 0 0-225 125 0z m30 193l-15 0 0-25 15 0z m0-40l-15 0 0-25 15 0z m0-40l-15 0 0-25 15 0z m0-40l-15 0 0-25 15 0z m0-40l-15 0 0-25 15 0z m0-40l-15 0 0-25 15 0z m0-80l-83 0c-5 0-8 3-8 7 0 4 3 8 8 8l83 0 0 25-424 0 0-25 308 0c4 0 8-4 8-8 0-4-4-7-8-7l-308 0 0-25 424 0z m-241 70l-130 0c-4 0-8 3-8 7l0 100c0 4 4 8 8 8l130 0c4 0 7-4 7-8l0-100c0-4-3-7-7-7z m-8 100l-115 0 0-85 115 0z"/>
      </symbol>
      <symbol id="icon-night" viewBox="0 0 512 512">
        <path d="m472 340c-3-3-7-4-11-3-116 48-249-7-297-123-24-58-23-125 4-182 3-6 0-12-5-15-3-1-6-1-9 0-127 52-187 198-135 325 52 127 197 187 324 135 58-24 105-69 131-125 2-4 1-9-2-12z m-223 134c-126 0-228-101-227-227 0-82 44-158 116-198-8 25-13 51-13 78 0 137 112 249 249 249 23 0 46-3 68-10-41 67-114 108-193 108z"/>
      </symbol>
      <symbol id="icon-tub" viewBox="0 0 512 512">
        <path d="m503 283c6-6 9-14 9-22 0-17-14-31-31-31l-65 0c-1-9-8-16-17-16l-57 0c-9 0-16 7-17 16l-156 0c-4 0-7 3-7 7 0 5 3 8 7 8l155 0 0 32-293 0c-9 0-16-7-16-16 0-4 2-8 5-11 3-3 7-5 11-5l103 0c5 0 8-3 8-8 0-4-3-7-8-7l-103 0c-8 0-16 3-22 9-6 6-9 14-9 22 0 14 9 26 22 30l0 42c-4 0-7 3-7 7 0 4 3 7 7 7l0 49c-4 0-7 3-7 7 0 4 3 7 7 7l0 49c-4 1-7 4-7 7 0 5 4 8 8 8l5 0c0 0 1 0 1 0l454 0c0 0 1 0 1 0l5 0c4 0 8-3 8-8 0-3-3-6-7-7l0-49c4 0 7-3 7-7 0-4-3-7-7-7l0-48c4-1 7-4 7-8 0-4-3-7-7-7l0-42c5-2 9-4 13-8z m-164-51c0-2 2-3 3-3l57 0c1 0 2 1 2 3l0 101-62 0z m-302 60l287 0 0 41-287 0z m438 103l-202 0c-4 0-7 4-7 8 0 4 3 7 7 7l202 0 0 49-438 0 0-49 202 0c4 0 7-3 7-7 0-4-3-8-7-8l-202 0 0-47 294 0c0 0 1 0 1 0l77 0c0 0 1 0 1 0l65 0 0 20-51 0c-4 0-8 4-8 8 0 4 4 7 8 7l51 0z m0-62l-59 0 0-41 59 0z m6-56l-65 0 0-32 65 0c9 0 16 7 16 16 0 4-2 8-5 12-3 2-7 4-11 4z m-337 84l-34 0c-4 0-7 4-7 8 0 4 3 7 7 7l34 0c4 0 8-3 8-7 0-4-4-8-8-8z m158 70l-59 0c-4 0-7 3-7 8 0 4 3 7 7 7l59 0c4 0 7-3 7-7 0-5-3-8-7-8z m-75-125l-38 0c-4 0-7 3-7 8 0 4 3 7 7 7l38 0c4 0 7-3 7-7 0-5-3-8-7-8z m243-136l-36 0c-4 0-8 3-8 8 0 4 4 7 8 7l36 0c4 0 8-3 8-7 0-5-4-8-8-8z m-122 7l-36 0c-4 0-8 3-8 7 0 4 4 8 8 8l36 0c4 0 8-4 8-8 0-4-4-7-8-7z m144-52l-21 0c-4 0-7 3-7 8 0 4 3 7 7 7l21 0c4 0 7-3 7-7 0-5-3-8-7-8z m-116 0l-82 0c-4 0-7 3-7 8 0 4 3 7 7 7l82 0c4 0 8-3 8-7 0-5-4-8-8-8z m-167 45l-37 0c-4 0-7 3-7 8 0 4 3 7 7 7l37 0c4 0 7-3 7-7 0-5-3-8-7-8z m-99 7l-69 0c-4 0-7 3-7 7 0 4 3 8 7 8l69 0c5 0 8-4 8-8 0-4-3-7-8-7z m120-81l-21 0c-4 0-7 3-7 7 0 4 3 8 7 8l21 0c4 0 8-4 8-8 0-4-4-7-8-7z m-96 29l-24 0c-4 0-7 3-7 8 0 4 3 7 7 7l24 0c5 0 8-3 8-7 0-5-3-8-8-8z m287-48l-20 0c-5 0-8 3-8 7 0 4 3 8 8 8l20 0c4 0 8-4 8-8 0-4-4-7-8-7z m-277-39l-57 0c-4 0-8 3-8 7 0 5 4 8 8 8l57 0c4 0 8-3 8-8 0-4-4-7-8-7z m195 10l-46 0c-4 0-8 4-8 8 0 4 4 7 8 7l46 0c4 0 8-3 8-7 0-4-4-8-8-8z"/>
      </symbol>
      <symbol id="ico-filt" viewBox="0 0 512 512">
        <path d="m368 378c0 0 0 0 0 0-4 0-6-2-6-6l1-353c0-3 3-6 6-6 0 0 0 0 0 0 3 0 6 3 6 6l-1 353c0 4-3 6-6 6z m0 71c-22 0-40-18-40-40 0-22 18-40 40-40 22 0 40 18 40 40 0 22-18 40-40 40z m0-70c-16 0-30 13-30 30 0 16 14 30 30 30 17 0 30-14 30-30 0-17-13-30-30-30z m0 127c0 0 0 0 0 0-4 0-6-3-6-6l1-55c0-3 3-6 6-6 4 0 6 3 6 6l-1 55c0 4-3 6-6 6z m-118-411c-3 0-6-2-6-6l0-70c0-3 3-6 6-6 4 0 6 3 6 6l0 70c0 4-2 6-6 6z m0 72c-22 0-40-18-40-40 0-22 18-40 40-40 22 0 40 18 40 40 0 22-18 40-40 40z m0-70c-16 0-30 13-30 30 0 16 14 30 30 30 17 0 30-14 30-30 0-17-13-30-30-30z m0 409c-3 0-6-2-6-6l0-330c0-4 3-6 6-6 4 0 6 2 6 6l0 330c0 4-2 6-6 6z m-118-281c-3 0-6-3-6-6l0-200c0-3 3-6 6-6 4 0 6 3 6 6l0 200c0 3-2 6-6 6z m0 75c-22 0-40-18-40-40 0-22 18-40 40-40 22 0 40 18 40 40 0 22-18 40-40 40z m0-70c-16 0-30 14-30 30 0 17 14 30 30 30 17 0 30-13 30-30 0-16-13-30-30-30z m0 276c-3 0-6-2-6-6l0-199c0-3 3-6 6-6 4 0 6 3 6 6l0 199c0 4-2 6-6 6z"/>
      </symbol>
      <symbol id="icon-cara" viewBox="0 0 512 512">
        <path d="m254 56c-1 0-12 4-26 9-22 7-52 17-187 63-20 7-38 13-39 13l-2 1 0 252 28 0c24 0 28 1 28 1 0 1 0 2-1 4-8 18-2 39 15 51 15 10 36 8 50-5 12-12 16-27 10-44-1-4-1-5-1-6 1 0 30-1 46-1l9 0 0 63 144 0 0-63 15 1c22 0 50 0 51 1 0 0 0 1-1 3-4 8-5 19-3 26 4 14 14 25 27 29 6 2 15 3 21 1 13-3 23-10 29-23 3-6 3-7 3-18 0-9 0-9-2-14l-2-5 16 0c9 0 19-1 23-1l7 0 0-252-9-3c-12-4-65-22-114-39-116-39-130-44-132-44-1 0-2 0-3 0z m31 31c71 23 205 69 206 70 0 0 0 32 1 109l0 108-27 0c-15 0-52 1-82 1l-55 0 0-205-144 0 0 205-55 0c-30 0-67-1-82-1l-27 0 0-109 1-108 22-8c21-7 55-19 132-45 48-16 80-27 80-27 1 0 14 4 30 10z m22 196l0 92-102 0 0-184 102 0z m0 117l0 6-102 0 0-5c0-3 0-5 0-6 0 0 9-1 51 0l51 0z m-211-4c4 1 7 2 10 5 6 6 8 15 4 23-5 12-21 15-31 6-9-7-9-21-1-29 3-3 5-4 9-5 3-1 4-1 9 0z m343 1c4 2 8 7 9 10 2 4 2 14 1 17-1 2-6 7-9 9-10 6-23 2-28-9-1-3-2-4-2-9 0-5 1-6 2-8 1-3 6-8 9-9 5-3 13-3 18-1z m-132 34l0 5-102 0 0-10 102 0z m-256-200l0 62 103 0 0-123-103 0z m82 0l0 41-61 0 0-81 61 0z m225 0l0 62 103 0 0-123-103 0z m82 0l0 41-61 0 0-81 61 0z"/>
      </symbol>
      <symbol id="icon-big" viewBox="0 0 512 512">
        <path d="m237 432c3 0 5-1 7-3 2-2 3-4 3-7 0-2-1-5-3-7-2-2-4-3-7-3-3 0-5 1-7 3-2 2-3 5-3 7 0 3 1 5 3 7 2 2 4 3 7 3z m-79-98l-69 0c-6 0-10 5-10 10l0 99c0 5 4 10 10 10l69 0c5 0 10-5 10-10l0-99c0-5-5-10-10-10z m-10 20l0 30-49 0 0-30z m-49 79l0-30 49 0 0 30z m256 20l69 0c5 0 10-5 10-10l0-99c0-5-5-10-10-10l-69 0c-6 0-10 5-10 10l0 99c0 5 4 10 10 10z m10-20l0-30 49 0 0 30z m49-79l0 30-49 0 0-30z m-256-168l-69 0c-6 0-10 5-10 10l0 99c0 5 4 10 10 10l69 0c5 0 10-5 10-10l0-99c0-5-5-10-10-10z m-10 20l0 30-49 0 0-30z m-49 79l0-30 49 0 0 30z m108 20l98 0c5 0 10-5 10-10l0-99c0-5-5-10-10-10l-98 0c-5 0-10 5-10 10l0 99c0 5 5 10 10 10z m10-20l0-30 78 0 0 30z m78-79l0 30-78 0 0-30z m60 99l69 0c5 0 10-5 10-10l0-99c0-5-5-10-10-10l-69 0c-6 0-10 5-10 10l0 99c0 5 4 10 10 10z m10-20l0-30 49 0 0 30z m49-79l0 30-49 0 0-30z m79 286l-10 0 0-325 9 0c0 0 0 0 0 0 6 0 10-5 10-10 0-2 0-3-1-4l-38-107c-2-4-6-6-10-6l-19 0 0-30c0-6-4-10-10-10l-59 0c-6 0-10 4-10 10l0 30-296 0c-4 0-8 2-10 6l-39 107c-1 3 0 7 1 9 2 3 5 5 9 5l9 0 0 325-10 0c-5 0-10 5-10 10 0 6 5 10 10 10l474 0c5 0 10-4 10-10 0-5-5-10-10-10z m-118-472l39 0 0 20-39 0z m-309 39l380 0 32 88-444 0z m-17 108l414 0 0 325-148 0 0-148c0-5-5-10-10-10l-98 0c-5 0-10 5-10 10l0 148-148 0z m246 325l-78 0 0-138 78 0z"/>
      </symbol>
      <symbol id="icon-group" viewBox="0 0 512 512">
        <path d="m437 229c-16-8-46-8-48-8-3 0-7 3-7 7 0 4 4 7 7 7 8 0 31 1 42 6 3 2 7 1 9-3 2-3 0-7-3-9z m34 98l-28-8c-2 0-2-1-2-3l0-9c2-2 4-3 6-5 10-10 16-23 16-37l0-13 3-6c3-6 4-13 4-20l0-35c0-4-3-7-7-7l-66 0c-24 0-44 20-44 44l0 0c0 6 1 11 4 17l3 7 0 11c0 17 9 33 22 43l0 10c0 2 0 3-5 4l-14 4-40-14c0-2-1-4-2-6l-13-13 0-23c1-1 3-2 4-3 16-16 25-37 25-59l0-18c5-11 8-22 8-34l0-74c0-4-3-7-7-7l-104 0c-36 0-66 30-66 66l0 15c0 12 3 23 8 34l0 15c0 26 11 49 29 65l0 23-13 13c-1 2-2 4-1 6l-43 15c-3 1-6 3-8 5l-7-4c20-8 26-21 26-21 1-2 1-4 0-6-5-10-5-29-6-43 0-5 0-10 0-14-3-33-28-58-59-58-31 0-56 25-59 58 0 4 0 9 0 14-1 14-1 33-6 43-1 2-1 4 0 6 0 0 6 13 26 21l-18 9c-10 5-16 15-16 26l0 52c0 3 3 6 7 6 3 0 6-3 7-6 0 0 0 0 0 0l0-52c-1-5 3-11 8-13l23-12 8 8c11 11 29 11 40 0l8-8 8 4c-4 6-6 13-6 19l0 54c0 3 3 6 7 6 4 0 7-3 7-6l0-54c0-9 6-18 15-21l45-16 18 28c3 3 7 6 11 6 0 0 1 0 1 0 4 0 8-1 10-4l12-11 0 72c0 3 3 6 7 6 3 0 7-3 7-6 0 0 0 0 0 0l0-72 11 11c3 3 6 4 10 4 0 0 1 0 1 0 5 0 9-3 11-6l19-28 44 16c9 3 15 12 15 21l0 54c0 3 3 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-54c0-9-4-18-10-25l2 0c1-1 4-2 6-3l18 18 0 64c0 3 3 6 7 6 3 0 6-3 6-6 0 0 0 0 0 0l0-64 18-18c1 1 2 1 3 2l28 8c7 2 12 8 12 14l0 58c0 3 3 6 6 6 4 0 7-3 7-6 0 0 0 0 0 0l0-58c0-13-8-24-21-28z m-406-12c-13-4-19-11-22-14 2-5 3-11 4-17 4 9 10 17 18 23z m40 19c-6 5-16 5-21 0l-7-6c1-2 2-5 2-7l0-7c10 3 20 3 30 0l0 7c0 2 1 5 2 7z m-11-32c-21 0-37-17-37-37 0-4-3-7-7-7-1 0-1 0-1 0 0-1 0-1 0-2 0-5 0-9 0-13 1-12 6-24 14-32 8-9 19-13 31-13 12 0 23 4 31 13 8 8 13 20 14 32 0 4 0 8 0 13 0 1 1 1 1 1-8-11-20-20-35-25-13-4-25-4-26-4-2 0-3 1-5 2l-12 13c-3 3-3 7 0 10 3 3 7 3 10 0l10-11c9 1 38 4 49 29-3 18-18 31-37 31z m29 13l0-8c8-6 15-13 18-23 1 6 2 12 4 17-2 3-9 10-22 14z m67-112l0-17c0-1-1-2-1-3-4-9-7-19-7-29l0-15c0-29 24-52 52-52l97 0 0 67c0 10-2 20-7 29 0 1 0 2 0 3l0 20c0 18-8 36-22 49-1 1-3 3-5 4 0 0 0 0 0 0-13 10-29 15-45 13-35-2-62-32-62-69z m39 139c-1 0-1 0-1 0 0 0 0 0 0 0l-22-32 7-7 33 22z m28-27l-38-25 0-13c10 5 21 9 32 9 2 0 4 0 6 0 13 0 25-3 37-9l0 13z m28 27c0 0 0 0 0 0 0 0 0 0 0 0l-18-17 33-22 7 7z m127-6l-16-15c0-2 0-3 0-5l0-2c5 1 9 2 14 2 1 0 1 0 2 0 5 0 10-1 15-2l0 2c0 2 0 3 0 4z m26-44c-8 7-17 10-28 10-20 0-36-18-36-39l0-13c0-1 0-2-1-3l-4-9c-1-3-2-6-2-10l0 0c0-17 13-30 30-30l59 0 0 28c0 5-1 10-3 14l-3 7c-1 1-1 2-1 3l0 15c0 10-4 20-11 27z m18 69c-4 0-7 3-7 7l0 45c0 3 3 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-45c0-4-3-7-7-7z m-399 9c-4 0-7 4-7 7l0 36c0 3 3 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-36c0-3-3-7-7-7z m256-214c-26-26-81-21-103-17-7 1-12 7-12 14l0 16c0 4 3 7 7 7 4 0 7-3 7-7 0 0 0 0 0 0l0-16c0 0 0-1 0-1 9-1 27-3 45-2 22 2 37 7 46 16 3 3 7 3 10 0 3-2 3-7 0-10 0 0 0 0 0 0z m-138 220c-3 0-7 3-7 7l0 30c0 3 4 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-30c0-4-3-7-7-7z m163 0c-4 0-7 3-7 7l0 30c0 3 3 6 7 6 4 0 7-3 7-6 0 0 0 0 0 0l0-30c0-4-3-7-7-7z"/>
      </symbol>
    </svg>
    <div class="filters" :class="{'show': $props.showFilters}">
      <div class="section features">
        <h3>Features</h3>
        <Checkbox
                :data.sync="$props.filter.wifi"
                :item="'Wifi'"
                :icon="'#icon-wifi'"
                @track="$props.track"
        />
        <Checkbox
                :data.sync="$props.filter.hot_tub"
                :item="'Hot Tub'"
                :icon="'#icon-tub'"
                @track="$props.track"
        />
      </div>
      <Checkbox
              :data.sync="$props.filter.pets"
              :item="'Pets'"
              :icon="'#icon-pet'"
              @track="$props.track"
      />
      <div class="section beds">
        <h3>Bedrooms</h3>
          <Select
            :data.sync="$props.filter.beds"
            :options="options.bedroom"
            :name="'Bedrooms'"
            :placeholder="'Bedrooms'"
            :required="false"
            :classN="'light'"
            :icon="'#icon-bed'"
            @track="$props.track"
          />
      </div>
      <div class="section sleeps">
        <h3>Sleeps</h3>
          <Select
            :data.sync="$props.filter.sleeps"
            :options="options.guest"
            :name="'Guests'"
            :placeholder="'Guests'"
            :classN="'light'"
            :required="true"
            :icon="'#icon-group'"
            @track="$props.track"
          />
      </div>
      <div class="section accomm">
        <h3>Accommodation</h3>
        <Checkbox
            :data.sync="$props.filter.lodge"
            :item="'Lodge'"
            :icon="'#icon-cottage'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.caravan"
            :item="'Caravan'"
            :icon="'#icon-cara'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.cottage"
            :item="'Cottage'"
            :icon="'#icon-cottage'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.apartment"
            :item="'Apartment'"
            :icon="'#icon-big'"
            @track="$props.track"
        />
      </div>

      <div class="right">
        <button class="btn" @click="$emit('closeAndCancel', false)">Close</button>
        <button class="btn orange" @click="$emit('getData', false)">Apply</button>
      </div>
    </div>

    <div class="mobile-filters" v-if="$props.isMobile" :class="{'show': $props.showFilters && $props.isMobile}">
        <div class="head">
          <div class="close" @click="$emit('closeAndCancel', false)">✕</div>
        </div>
    <div class="padding">
      <div class="section features">
        <h3>Features</h3>
        <Checkbox
                :data.sync="$props.filter.wifi"
                :item="'Wifi'"
                :icon="'#icon-wifi'"
                @track="$props.track"
        />
        <Checkbox
                :data.sync="$props.filter.hot_tub"
                :item="'Hot Tub'"
                :icon="'#icon-tub'"
                @track="$props.track"
        />
      </div>
      <div class="section beds">
        <h3>Bedrooms</h3>
          <Select
            :data.sync="$props.filter.beds"
            :options="options.bedroom"
            :name="'Bedrooms'"
            :placeholder="'Bedrooms'"
            :required="false"
            :classN="'light'"
            :icon="'#icon-bed'"
            @track="$props.track"
          />
      </div>
      <div class="section sleeps">
        <h3>Sleeps</h3>
          <Select
            :data.sync="$props.filter.sleeps"
            :options="options.guest"
            :name="'Guests'"
            :placeholder="'Guests'"
            :classN="'light'"
            :required="true"
            :icon="'#icon-group'"
            @track="$props.track"
          />
      </div>
      <div class="section accomm">
        <h3>Accommodation</h3>
        <Checkbox
            :data.sync="$props.filter.lodge"
            :item="'Lodge'"
            :icon="'#icon-cottage'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.caravan"
            :item="'Caravan'"
            :icon="'#icon-cara'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.cottage"
            :item="'Cottage'"
            :icon="'#icon-cottage'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.apartment"
            :item="'Apartment'"
            :icon="'#icon-big'"
            @track="$props.track"
        />
      </div>
    <div class="right">
      <button class="btn" @click="$emit('closeAndCancel', false)">Close</button>
      <button class="btn orange" @click="$emit('getData', false)">Apply</button>
    </div>
      </div>
    </div>

  </div>
</template>

<script>
import Checkbox from 'shared/checkbox.vue';
import Select from 'shared/select.vue';

export default {
   data: function () {
      return {
      }
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    showFilters: Boolean,
    isMobile: Boolean,
    options: Object,
    track: Function,
    formatActiveFilters: Function
  },
  components: {
      Checkbox, Select
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.filters {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  position: absolute;
  background: $col_white;
  width: 100%;
  left: 0;
  padding: 0 1rem;
  box-sizing: border-box;
  box-shadow: 0 0.125rem 0.25rem #ccc;
  z-index: 5;
  top: 10rem;

  &.show {
    max-height: 70rem;
    padding: 0 1rem 1rem;
  }
}

.section {
  padding: 1rem 0 0 0;
  clear: both;
}

h3 {
  margin: 0 0 1rem;
}

.right {
  padding: 1.25rem 0 2rem;
  clear: both;
}

.btn {
  width: 8rem;
  background: $col_grey;
  font-weight: 700;
  height: 2.5rem;
  font-size: .875rem;
  border-radius: .3rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.15);
  cursor: pointer;
  outline: none;

  &.orange {
    color: $col_white;
    background: $col_primary;
    margin: 0 0 0 .5rem;
  }

  &:focus {
    box-shadow: 0 0.125rem 1.25rem 0 #D3EFE4;
  }
}

.padding {
  padding: 1.25rem 1.25rem 0 1.25rem;
}

 .close {
    top: 0.625rem;
    left: 1.25rem;
    position: absolute;
    font-size: 1.4rem;
    z-index: 10;
    cursor: pointer;
  }

  .head {
    height: 3.125rem;
    position: relative;

    &:after{
      content: "";
      background: #919195;
      height: 0.063rem;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }

.mobile-filters {
  position: fixed;
  z-index: 10;
  height: 100%;
  background: $col_white;
  top: 0;
  left: 0;
  width: 100%;
  display: none;
  box-sizing: border-box;

  &.show {
    display: block;
  }

  .right {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 1.25rem;
    box-sizing: border-box;

    .btn {
      width: calc(30% - 0.625rem);
      float: left;
      margin: 0 0.625rem 0 0;

      &.orange {
        width: 70%;
        margin: 0;
      }
    }
  }
}

@media #{$desktop} {
  .btn {
    width: 12rem;
  }

  .filters {
    padding: 0 1.25rem;
    top: 5.313rem;

    &.show {
      padding: 0 1.25rem 0;
    }
  }
}

</style>